import { Icon as Iconify } from '@iconify/react';
import { lionIcons } from '../components/helpersIcons';
import PropTypes from 'prop-types';


export const CcTitle = (props) => {

    return <div className={`text-4xl font-semibold font-poppins text-ccColorDarkTeal ${props.className}`}>
    {props.children}
  </div>
  } 

export const CcSubSectionTitle = (props) => {

  return <div className={`text-xl font-medium font-poppins text-ccColorTeal ${props.className}`}>
  {props.children}
</div>
} 

export const CcCreateNewSnippet = (props) => {

  return <button type="button" className={`focus:outline-none text-white bg-ccColorSecondaryPink hover:bg-ccColorSecondaryPurple font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900 ${props.className}`}>
    <div className='flex flex-row gap-2 items-center font-poppins'>
      <Iconify icon={lionIcons.Icon_Actions_Add} width={26} />
      {props.children}
    </div>
    </button>
}
export const CcCreateNewButton = (props) => {

  const handleClick = (e) => {
    if (props.onClick) props.onClick(e);
  }

  return <button type="button" onClick={handleClick} className={`focus:outline-none text-white bg-ccColorSecondaryPink hover:bg-ccColorSecondaryPurple font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900 ${props.className}`}>
    <div className='flex flex-row gap-2 items-center font-poppins'>
      <Iconify icon={lionIcons.Icon_Actions_Add} width={26} />
      {props.children}
    </div>
    </button>
}
export const CcButtonPink = (props) => {

  const handleClick = (e) => {
    if (props.onClick) props.onClick(e);
  }

  return <button type="button" onClick={handleClick} className={`focus:outline-none text-white bg-ccColorSecondaryPink hover:bg-ccColorSecondaryPurple font-medium rounded-lg text-sm px-5 py-2.5 mb-2 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900 ${props.className}`}>
    <div className='flex flex-row gap-2 items-center justify-center font-poppins'>
      {props.children}
    </div>
    </button>
}

export const CcActionButton = (props) => {

  const handleClick = (e) => {
    if (props.onClick) props.onClick(e);
  }

  return props.disabled ?  <button disabled onClick={handleClick} type="button" className={`focus:outline-none text-white bg-gray-400 font-medium rounded-lg text-sm px-5 py-2.5 ${props.className === undefined ? '' : props.className}`}>
    <div className='flex flex-row gap-2 items-center font-poppins'>
      {props.children}
    </div>
    </button>
  :
    <button disabled={props.showSpinner} onClick={handleClick} type="button" className={`focus:outline-none text-white bg-ccColorTeal hover:bg-ccColorDarkTeal font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900 ${props.className === undefined ? '' : props.className}`}>
        <div className='flex flex-row gap-2 items-center font-poppins'>
          {props.showSpinner ? <div>
                                  <svg aria-hidden="true" className="w-6 h-6 text-gray-200 animate-spin dark:text-gray-600 fill-ccColorTeal" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor"/><path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill"/></svg>
                                </div>
          :
            props.children
          }
          
        </div>
    </button>
}

export const CcActionButtonOutlined = (props) => {

  const handleClick = (e) => {
    if (props.onClick) props.onClick(e);
  }

  const render = () => {
    switch(props.size) {
      case "small":
        return <button onClick={handleClick} type="button" className={`px-2 py-1 max-h-7 text-xs focus:outline-none text-ccColorTeal hover:text-white border border-ccColorTeal hover:bg-ccColorTeal font-medium rounded-lg dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900 ${props.className === undefined ? '' : props.className}`}>
        <div className='flex flex-row gap-2 items-center font-poppins'>
          {props.children}
        </div>
        </button>
      default:
        return <button onClick={handleClick} type="button" className={`focus:outline-none text-ccColorTeal hover:text-white border border-ccColorTeal hover:bg-ccColorTeal font-medium rounded-lg text-sm px-5 py-2.5 dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900 ${props.className === undefined ? '' : props.className}`}>
      <div className='flex flex-row gap-2 items-center font-poppins'>
        {props.children}
      </div>
      </button>
    }
  
  }

  return <>{render()}
        </>
}

export const CcSecondaryActionButtonOutlined = (props) => {

  const handleClick = (e) => {
    if (props.onClick) props.onClick(e);
  }

  const render = () => {
    return <button onClick={handleClick} type="button" className={`px-2 py-2 max-h-9 text-xs focus:outline-none text-ccColorTeal hover:text-white border border-ccColorTeal hover:bg-ccColorTeal font-medium rounded-lg dark:bg-purple-600 dark:hover:bg-purple-700 dark:focus:ring-purple-900 ${props.className === undefined ? '' : props.className}`}>
    <div className='flex flex-row gap-2 items-center font-poppins'>
      {props.children}
    </div>
    </button>

  }

  return <>{render()}
        </>
}

CcActionButtonOutlined.propTypes = {
  size: PropTypes.oneOf(['ExtraSmall', undefined]),
};